// src/utils/logger.js
/**
 * Centralized logging utility
 * Provides consistent logging across the application
 */
class Logger {
    static isDevelopment = process.env.NODE_ENV === 'development';
  
    static log(message, data = null) {
      if (this.isDevelopment) {
      }
    }
  
    static error(message, error = null) {
      if (this.isDevelopment) {
        console.error(`[${new Date().toISOString()}] ERROR: ${message}`, error || '');
      }
    }
  
    static warn(message, data = null) {
      if (this.isDevelopment) {
        console.warn(`[${new Date().toISOString()}] WARNING: ${message}`, data || '');
      }
    }
  }
  
  export default Logger;